import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesTeamsCreateRoute extends Route {
  @service store;

  model() {
    return this.store.createRecord('team', {});
  }
}

export default instrumentRoutePerformance(ResourcesTeamsCreateRoute);
